import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import Button from "components/basic/button";

export const QUOTE_FLOW_NAV_HEIGHT = 80;

interface QuoteFlowNavProps {
  /** Return to the estimate list. */
  onBack: () => void;
  /**
   * Open the next recommendation's quote. Omitted (button hidden) when the
   * current quote is the last one.
   */
  onNextQuote?: () => void;
}

/**
 * Bottom navigation for the quote page, mirroring the select-estimate bar:
 * back to the estimate list, and paging through the remaining recommendations.
 */
const QuoteFlowNav: React.FC<QuoteFlowNavProps> = ({ onBack, onNextQuote }) => {
  const { t } = useTranslation("estimator");
  const theme = useTheme();

  return (
    <div
      style={{
        backgroundColor: theme.palette.primary.main,
        height: QUOTE_FLOW_NAV_HEIGHT,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: theme.spacing(2),
      }}
    >
      <Button
        style={{
          color: theme.palette.common.white,
          fontSize: "1.4em",
          fontWeight: "bold",
          padding: `0 ${theme.spacing(3.5)}`,
        }}
        variant="contained"
        color="warning"
        onClick={onBack}
        size="large"
      >
        {t("quote.back")}
      </Button>

      {onNextQuote && (
        <Button
          style={{
            color: theme.palette.common.black,
            fontSize: "1.4em",
            fontWeight: "bold",
            padding: `0 ${theme.spacing(3.5)}`,
          }}
          variant="contained"
          color="secondary"
          onClick={onNextQuote}
          size="large"
        >
          {t("quote.next_quote")}
        </Button>
      )}
    </div>
  );
};

export default QuoteFlowNav;
